import {Form, MultiCascader} from "rsuite";
import React, {useEffect, useMemo, useState} from "react";
import {getSkills} from "../../../../../service/dataService";

const SkillSearchForm = () => {
    const [skillBuckets, setSkillBuckets] = useState([]);

    useEffect(() => {
        getSkills().then((data) => {
            const skillBuckets = {};
            data.forEach((skill) => {
                if (skillBuckets[skill.skillType] === undefined) {
                    skillBuckets[skill.skillType] = [];
                }
                skillBuckets[skill.skillType].push({label: skill.skillName, value: skill.skillName});
            });
            const treeData = [];
            Object.keys(skillBuckets).forEach((key) =>  {
                const row = {label: key, value: key};
                row.children = skillBuckets[key];
                treeData.push(row);
            });
            setSkillBuckets(treeData);
        });
      }, []);


    return useMemo(() => {
        return (
            <>
                <Form.Group>
                    <Form.ControlLabel>Skill Name</Form.ControlLabel>
                    <Form.Control name="skillName"
                                  menuWidth={300}
                                  menuHeight={300}
                                  accepter={MultiCascader}
                                  data={skillBuckets}
                                  style={{ width: 300 }}
                                  uncheckableItemValues={skillBuckets.map((item) => item.label)}
                    />
                </Form.Group>
            </>
        );
        }, [skillBuckets]);
};

export default SkillSearchForm;